var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32.001"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17346",
    d: "M31.558 29.367L18.122 15.995 31.495 2.557A1.5 1.5 0 0029.368.442L15.995 13.88 2.558.507A1.5 1.5 0 10.443 2.634L13.88 16.006.507 29.443a1.5 1.5 0 102.127 2.115l13.372-13.436 13.437 13.373a1.5 1.5 0 102.115-2.127",
    fill: "currentColor"
  })));
}
export default SvgClose;